<template>
	<section class="section-statistics">
		<app-actions :resource-uri="$route.name" @run-action="runAction" />
		<!--<template>
			<v-layout xs2 mt-5 ml-5 mr-5>
				<v-flex xs2 px-2>
					<HeaderSelect
						placeholder="Selección de Fechas"
						class="select"
						item-text="name"
						item-value="id"
						:items="typesDate"
						:disabled="$route.meta.noChangeCompany"
						:height="33"
						@input="getDataDate($event)"
					/>
				</v-flex>
				<v-flex xs1 mt-1 v-if="flagDate"
					><label class="caption">Fecha Desde:</label></v-flex
				>
				<v-flex xs2 v-if="flagDate">
					<date-component-dashboard
						round
						:date="model.startDate"
						place-holder="hola"
						icon="/static/img/calendar.svg"
						@on-input="getDate({ model: 'startDate', value: $event })"
					></date-component-dashboard>
				</v-flex>
				<v-flex xs1 mt-1 v-if="flagDate"
					><label class="caption">Fecha Hasta:</label></v-flex
				>
				<v-flex xs2 v-if="flagDate">
					<date-component-dashboard
						round
						:date="model.endDate"
						icon="/static/img/calendar.svg"
						@on-input="getDate({ model: 'endDate', value: $event })"
					></date-component-dashboard>
				</v-flex>
			</v-layout>
		</template>-->
		<template>
			<div class="card-container">
				<v-card
					class="custom-card mx-auto elevation-20"
					color="rgb(0, 227, 150) !important"
					dark
				>
					<v-layout justify-space-between>
						<v-flex xs8>
							<v-card-title primary-title>
								<div>
									<div class="headline">Ingresos Totales</div>
									<div class="headlineForMonth">
										Año Actual<br />
										$ {{ (accountFourTotalForYear * -1).toFixed(2) }}
										<div class="headlineForMonth">
											Mes Actual<br />
											$ {{ (accountFourTotalForMonth * -1).toFixed(2) }}
										</div>
									</div>
								</div>
							</v-card-title>
						</v-flex>
						<img
							class="shrink ma-2"
							src="https://maki-bucket.s3.amazonaws.com/Maki_Contabilidad_exe/ingresos.png"
							alt="Album Cover"
							style="flex-basis: 140px; height: 140px;"
						/>
					</v-layout>
				</v-card>
				<v-card
					class="custom-card mx-auto elevation-20"
					color="rgba(0,143,251,1) !important"
					dark
				>
					<v-layout justify-space-between>
						<v-flex xs8>
							<v-card-title primary-title>
								<div>
									<div class="headline">Costos Totales</div>
									<div class="headlineForMonth">
										Año Actual<br />
										$ {{ accountFiveTotalForYear.toFixed(2) }}
										<div class="headlineForMonth">
											Mes Actual <br />
											$ {{ accountFiveTotalForMonth.toFixed(2) }}
										</div>
									</div>
								</div>
							</v-card-title>
						</v-flex>
						<img
							class="shrink ma-2"
							src="https://maki-bucket.s3.amazonaws.com/Maki_Contabilidad_exe/costos.png"
							alt="Album Cover"
							style="flex-basis: 140px; height: 140px;"
						/>
					</v-layout>
				</v-card>
				<v-card
					class="custom-card mx-auto elevation-20"
					color="#02979b !important"
					dark
				>
					<v-layout justify-space-between>
						<v-flex xs8>
							<v-card-title primary-title>
								<div>
									<div class="headline">Gastos Totales</div>
									<div class="headlineForMonth">
										Año Actual<br />
										$ {{ accountSixTotalForYear.toFixed(2) }}
										<div class="headlineForMonth">
											Mes Actual<br />
											$ {{ accountSixTotalForMonth.toFixed(2) }}
										</div>
									</div>
								</div>
							</v-card-title>
						</v-flex>
						<img
							class="shrink ma-2"
							src="https://maki-static.s3.amazonaws.com/001_image/menuMaki/ICONO_Mesa+de+trabajo+1.png"
							alt="Album Cover"
							style="flex-basis: 140px; height: 140px;"
						/>
					</v-layout>
				</v-card>
				<v-card
					class="custom-card mx-auto elevation-20"
					color="rgba(254,176,25,0.85) !important"
					dark
				>
					<v-layout justify-space-between>
						<v-flex xs8>
							<v-card-title primary-title>
								<div>
									<div class="headline">Utilidad Total</div>
									<div class="headlineForMonth">
										Año Actual<br />
										$ {{ (accountFourTotalForYear * -1).toFixed(2) }}
										<div class="headlineForMonth">
											Mes Actual<br />
											$ {{ (accountFourTotalForMonth * -1).toFixed(2) }}
										</div>
									</div>
								</div>
							</v-card-title>
						</v-flex>
						<img
							class="shrink ma-2"
							src="https://maki-bucket.s3.amazonaws.com/Maki_Contabilidad_exe/utilidad.png"
							alt="Album Cover"
							style="flex-basis: 140px; height: 140px;"
						/>
					</v-layout>
				</v-card>
			</div>
		</template>
		<template>
			<template>
				<v-layout xs2 mt-3 ml-5 mr-5>
					<v-flex xs2 px-2>
						<HeaderSelect
							placeholder="Selección de Fechas"
							class="select"
							item-text="name"
							item-value="id"
							:items="typesDate"
							:disabled="$route.meta.noChangeCompany"
							:height="33"
							@input="getDataDate($event)"
						/>
					</v-flex>
					<v-flex xs1 mt-1 v-if="flagDate"
						><label class="caption">Fecha Desde:</label></v-flex
					>
					<v-flex xs2 v-if="flagDate">
						<date-component-dashboard
							round
							:date="model.startDate"
							place-holder="hola"
							icon="/static/img/calendar.svg"
							@on-input="getDate({ model: 'startDate', value: $event })"
						></date-component-dashboard>
					</v-flex>
					<v-flex xs1 mt-1 v-if="flagDate"
						><label class="caption">Fecha Hasta:</label></v-flex
					>
					<v-flex xs2 v-if="flagDate">
						<date-component-dashboard
							round
							:date="model.endDate"
							icon="/static/img/calendar.svg"
							@on-input="getDate({ model: 'endDate', value: $event })"
						></date-component-dashboard>
					</v-flex>
				</v-layout>
			</template>
			<layout>
				<v-flex mr-5 ml-5 mt-2>
					<div class="card-container-graphics">
						<v-card
							v-for="(card, index) in cards"
							:key="index"
							class="custom-card-graphics mx-auto elevation-20"
							color="white"
							dark
							max-width="800"
						>
							<div class="custom-card-container">
								<div class="custom-card-background">
									<template v-if="index === 0">
										<dashed
											:series="seriesGraphics"
											:chartOptions="chartOptions"
										/>
									</template>
									<template v-if="index === 1">
										<pie />
									</template>
									<template v-if="index === 2">
										<!--	<donut />
										Donut para los otros v-card -->
									</template>
								</div>
								<div class="card-title">{{ card.title }}</div>
								<!-- Título de la tarjeta -->
							</div>
							<!-- 	<v-card-text>
								<div class="display-1 font-weight-thin">
									{{ card.subtitle }}
								</div>
							</v-card-text>

							<v-divider></v-divider>

							<v-card-actions class="justify-center">
								<v-btn block flat>Go to Report</v-btn>
							</v-card-actions> -->
						</v-card>
					</div>
				</v-flex>
			</layout>
		</template>
		<!--	<v-layout row wrap justify-start mt-5>
		<v-flex class="contentFilter"  md2 mx-5 lg3 >
			<BaseSelect
				class="select-accouting"
				label="Módulos"
				item-text="name"
				item-value="id"
				:items="records"
				v-model="moduleId"
				:value="moduleId"
				@input="setModule($event)"
				:height="38"
			/>
		</v-flex>
		</v-layout>!-->

		<!--<v-layout class="graphics-content" row wrap mt-5 justify-space-around>
			<v-flex row wrap xs5 justify-center>
				<div class="bar-chart">
					<span class="reports mx-3">
						Reportes
					</span>
					<barchart />
				</div>
			</v-flex>
			<v-flex row wrap xs5 justify-center>
				<div class="do-nut">
					<span class="reports mx-3">
						Estadisticas
					</span>
					<donut />
				</div>
			</v-flex>
		</v-layout>
		<v-layout class="graphics-contentMovil" row wrap mt-2 justify-space-around>
			<v-flex row wrap xs2 justify-center>
				<div class="bar-chartMovil">
					<span class="reports mx-3">
						Reportes
					</span>
					<barchartMovil />
				</div>
			</v-flex>
			<v-flex row wrap xs2 justify-center>
				<div class="do-nutMovil">
					<span class="reports mx-3">
						Estadisticas
					</span>
					<dashed />
				</div>
			</v-flex>
		</v-layout> -->
	</section>
</template>

<script>
import { format, subDays } from 'date-fns';
import actionBar from '@/components/shared/action-bar/action-bar';
import customerList from '@/components/customers/customer-list';
import appActions from '@/components/shared/app-actions/app-actions';
import dashed from '@/components/shared/apexCharts/dashed';
import barchart from '@/components/shared/apexCharts/bar-chart';
import donut from '@/components/shared/apexCharts/donut';
import pie from '@/components/shared/apexCharts/pie';
import barchartMovil from '@/components/shared/apexCharts/bar-chartMovil';
import BaseSelect from '@/components/shared/inputs/base-select';
import { mapGetters, mapActions } from 'vuex';
import dateComponentDashboard from '@/components/autocomplete/date-component-dashboard';

async function created() {
	this.loadDataAmount(this.currentSubsidiary);
	this.loadDataAmountPurchases(this.currentSubsidiary);
	// this.loadRecords(this.currentSubsidiary);
}

function onSearchTable(value) {
	this.onSearch(value, 'customer');
	this.currentPage = 1;
}

async function loadDataAmount(currentSubsidiary) {
	const lastRecordDate = new Date(this.$today).getFullYear();
	const lastRecordMonth = new Date(this.$today).getMonth() + 1;
	try {
		const response = await this.$http.get(
			`sales-amount-total?subsidiaryId=${currentSubsidiary.id}&year=${lastRecordDate}&month=${lastRecordMonth}`,
		);
		this.totalAmountSales = response.data || 0;
		this.accountFourTotalForMonth =
			this.getTotalForAccountMonth(this.totalAmountSales, '4') || 0;
		this.accountFiveTotalForMonth =
			this.getTotalForAccountMonth(this.totalAmountSales, '5') || 0;
		this.accountSixTotalForMonth =
			this.getTotalForAccountMonth(this.totalAmountSales, '6') || 0;
		this.accountFourTotalForYear =
			this.getTotalForAccountYear(this.totalAmountSales, '4') || 0;
		this.accountFiveTotalForYear =
			this.getTotalForAccountYear(this.totalAmountSales, '5') || 0;
		this.accountSixTotalForYear =
			this.getTotalForAccountYear(this.totalAmountSales, '6') || 0;
	} catch (err) {
		if (err.status === 500) {
			this.showGenericError();
		} else if (err.status === 400) {
			this.showNotification(
				'Para visualizar el total de ventas, necesita elegir la sucursal',
				'warning',
			);
		}
	}
}
function getTotalForAccountMonth(totalsData, account) {
	const totalsArray = totalsData.totalsforMonth || [];
	const foundTotal = totalsArray.find(entry => entry.account === account);
	return foundTotal ? foundTotal.total : 0;
}
function getTotalForAccountYear(totalsData, account) {
	const totalsArray = totalsData.totalsforYear || [];
	const foundTotal = totalsArray.find(entry => entry.account === account);
	return foundTotal ? foundTotal.total : 0;
}

async function loadDataAmountPurchases(currentSubsidiary) {
	try {
		const response = await this.$http.get(
			`dashboard-amounts?subsidiaryId=${currentSubsidiary.id}&endDate=${this.model.endDate}&startDate=${this.model.startDate}`,
		);
		this.totalAmountPurchases = response.data || 0;
		const result = [];
		if (this.flagDays) {
			this.totalAmountPurchases.forEach((y) => {
				y.details.forEach((item) => {
					const flagmonth = true;
					if (flagmonth) {
						const dateParts = item.date.split('-');
						const newDay = dateParts[0];
						const newAmount = item.amount;
						const newAccount = y.account;

						result.push({
							account: newAccount,
							day: newDay,
							totalAmount: newAmount,
						});
					}
				});
			});
			const income = result.filter(item => item.account === '4');
			income.sort((a, b) => a.day - b.day);
			const sumsByDayIncome = {};
			const sumsByDayCosts = {};
			// Calcular las sumas de totalAmount por día
			income.forEach((item) => {
				if (!sumsByDayIncome[item.day]) {
					sumsByDayIncome[item.day] = item.totalAmount;
				} else {
					sumsByDayIncome[item.day] += item.totalAmount;
				}
			});

			// Crear un nuevo arreglo con los resultados de las sumas
			const summedIncome = Object.keys(sumsByDayIncome).map(i => ({
				day: i,
				totalAmount: sumsByDayIncome[i],
			}));
			const costs = result.filter(item => item.account === '5');
			costs.sort((a, b) => a.day - b.day);
			costs.forEach((item) => {
				if (!sumsByDayCosts[item.day]) {
					sumsByDayCosts[item.day] = item.totalAmount;
				} else {
					sumsByDayCosts[item.day] += item.totalAmount;
				}
			});

			// Crear un nuevo arreglo con los resultados de las sumas
			const summedCost = Object.keys(sumsByDayCosts).map(i => ({
				day: i,
				totalAmount: sumsByDayCosts[i],
			}));

			const utils = result.filter(item => item.account === '6');
			utils.sort((a, b) => a.day - b.day);
			const sumsByDayUtils = {};
			// Calcular las sumas de totalAmount por día
			utils.forEach((item) => {
				if (!sumsByDayUtils[item.day]) {
					sumsByDayUtils[item.day] = item.totalAmount;
				} else {
					sumsByDayUtils[item.day] += item.totalAmount;
				}
			});

			// Crear un nuevo arreglo con los resultados de las sumas
			const summedUtils = Object.keys(sumsByDayUtils).map(i => ({
				day: i,
				totalAmount: sumsByDayUtils[i],
			}));

			const fourAmounts = summedIncome.map(item =>
				Number((item.totalAmount * -1).toFixed(2)),
			);
			const FiveAmounts = summedCost.map(item =>
				Number(Math.abs(item.totalAmount).toFixed(2)),
			);
			const SixAmounts = summedUtils.map(item =>
				Number(Math.abs(item.totalAmount).toFixed(2)),
			);
			this.seriesGraphics = [
				{ name: 'Ingresos', data: fourAmounts || [0] },
				{ name: 'Costos', data: FiveAmounts || [0] },
				{ name: 'Gastos', data: SixAmounts || [0] },
			];
			const allDays = [
				...new Set([...income, ...costs].map(item => item.day)),
			].sort((a, b) => a - b);
			/* eslint-disable */
			const newChartOptions = {
				chart: {
					height: 505,
					type: 'line',
					zoom: {
						enabled: true,
					},
				},
				dataLabels: {
					enabled: true,
				},
				stroke: {
					width: [3, 3, 3], // Define el grosor de las líneas de cada serie
					curve: 'smooth', // Tipo de curva
					dashArray: [0, 0, 0], // Define el patrón de línea discontinua
				},
				xaxis: {
					categories: allDays,
				},
				tooltip: {
					y: [
						{
							title: {
								formatter: val => val + ' Total',
							},
						},
						{
							title: {
								formatter: val => val + ' Total',
							},
						},
					],
				},
			};
			this.chartOptions = newChartOptions;
		} else {
			const monthNames = [
				'Enero',
				'Febrero',
				'Marzo',
				'Abril',
				'Mayo',
				'Junio',
				'Julio',
				'Agosto',
				'Septiembre',
				'Octubre',
				'Noviembre',
				'Diciembre',
			];

			this.totalAmountPurchases.forEach((y) => {
				y.details.forEach((item) => {
					const flagmonth = true;
					if (flagmonth) {
						const dateParts = item.date.split('-');
						const newMonthNumber = parseInt(dateParts[1], 10); // Obtener número de mes
						const newMonthName = monthNames[newMonthNumber - 1]; // Obtener nombre de mes
						const newAmount = item.amount;
						const newAccount = y.account;

						result.push({
							account: newAccount,
							monthNumber: newMonthNumber,
							monthName: newMonthName,
							totalAmount: newAmount,
						});
					}
				});
			});

			const income = result.filter(item => item.account === '4');
			income.sort((a, b) => a.monthNumber - b.monthNumber);

			const sumsByMonthIncome = {};
			income.forEach((item) => {
				if (!sumsByMonthIncome[item.monthNumber]) {
					sumsByMonthIncome[item.monthNumber] = item.totalAmount;
				} else {
					sumsByMonthIncome[item.monthNumber] += item.totalAmount;
				}
			});
			const summedIncome = Object.keys(sumsByMonthIncome).map(i => ({
				monthNumber: parseInt(i, 10),
				monthName: monthNames[parseInt(i, 10) - 1],
				totalAmount: sumsByMonthIncome[i],
			}));
			const costs = result.filter(item => item.account === '5');
			costs.sort((a, b) => a.monthNumber - b.monthNumber);
			const sumsByMonthCosts = {};

			costs.forEach((item) => {
				if (!sumsByMonthCosts[item.monthNumber]) {
					sumsByMonthCosts[item.monthNumber] = item.totalAmount;
				} else {
					sumsByMonthCosts[item.monthNumber] += item.totalAmount;
				}
			});

			const summedCost = Object.keys(sumsByMonthCosts).map(i => ({
				monthNumber: parseInt(i, 10),
				monthName: monthNames[parseInt(i, 10) - 1],
				totalAmount: sumsByMonthCosts[i],
			}));
			////(//)
			const utils = result.filter(item => item.account === '6');
			utils.sort((a, b) => a.monthNumber - b.monthNumber);
			const sumsByMonthutils = {};

			utils.forEach((item) => {
				if (!sumsByMonthutils[item.monthNumber]) {
					sumsByMonthutils[item.monthNumber] = item.totalAmount;
				} else {
					sumsByMonthutils[item.monthNumber] += item.totalAmount;
				}
			});

			const summedUtils = Object.keys(sumsByMonthutils).map(i => ({
				monthNumber: parseInt(i, 10),
				monthName: monthNames[parseInt(i, 10) - 1],
				totalAmount: sumsByMonthutils[i],
			}));


			const fourAmounts = summedIncome.map(item =>
				Number((item.totalAmount * -1).toFixed(2)),
			);
			const FiveAmounts = summedCost.map(item =>
				Number(Math.abs(item.totalAmount).toFixed(2)),
			);
			const SixAmounts = summedUtils.map(item =>
				Number(Math.abs(item.totalAmount).toFixed(2)),
			);

			this.seriesGraphics = [
				{ name: 'Ingresos', data: fourAmounts || [0] },
				{ name: 'Costos', data: FiveAmounts || [0] },
				{ name: 'Gastos', data: SixAmounts || [0] },
			];

			const allMonths = [
				...new Set(
					[...income, ...costs].map(item => monthNames[item.monthNumber - 1]),
				),
			].sort((a, b) => monthNames.indexOf(a) - monthNames.indexOf(b));
			/* eslint-disable */
			const newChartOptions = {
				chart: {
					height: 505,
					type: 'line',
					zoom: {
						enabled: true,
					},
				},
				dataLabels: {
					enabled: true,
				},
				stroke: {
					width: [3, 3, 3], // Define el grosor de las líneas de cada serie
					curve: 'smooth', // Tipo de curva
					dashArray: [0, 0, 0], // Define el patrón de línea discontinua
				},
				xaxis: {
					categories: allMonths,
				},
				tooltip: {
					y: [
						{
							title: {
								formatter: val => val + ' Total',
							},
						},
						{
							title: {
								formatter: val => val + ' Total',
							},
						},
					],
				},
			};
			this.chartOptions = newChartOptions;
		}
	} catch (err) {
		if (err.status === 500) {
			this.showGenericError();
		} else if (err.status === 400) {
			this.showNotification(
				'Para visualizar el total de ventas, necesita elegir la sucursal',
				'warning',
			);
		}
	}
}

function getDate({ value, model }) {
	this.model[model] = format(value, 'YYYY-MM-DD');
	this.loadDataAmountPurchases(this.currentSubsidiary);
	this.loadDataAmount(this.currentSubsidiary);
}

async function loadRecords(newSubsidiary) {
	try {
		const { data: records, headers } = await this.$http.get(
			`accounting-plan/${newSubsidiary.id}/subsidiary?status=1&limit=30&page=1`,
		);
		this.lastPageSearcher = Number(headers['x-last-page']);
		this.records = [...records];
	} catch (err) {
		if (err.status === 500) {
			this.showGenericError();
		} else if (err.status === 400) {
			this.showNotification(
				'Para visualizar la grafica de Barras, necesita elegir una cuenta contable',
				'warning',
			);
		}
	}
}

function getDataDate(val) {
	if (val === 1) {
		this.model.startDate = this.$today;
		this.model.endDate = this.$today;
		this.flagDate = false;
		this.flagDays = true;
	} else if (val === 2) {
		this.model.startDate = format(subDays(this.$today, 7), 'YYYY-MM-DD');
		this.model.endDate = this.$today;
		this.flagDate = false;
		this.flagDays = true;
	} else if (val === 3) {
		const today = new Date(this.$today);
		const firstDayOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);
		this.model.startDate = firstDayOfMonth.toISOString().split('T')[0];
		this.model.endDate = this.$today;
		this.flagDate = false;
		this.flagDays = true;
	} else if (val === 4) {
		const today = new Date(this.$today);
		// Set the startDate to the first day of the current year
		const firstDayOfYear = new Date(today.getFullYear(), 0, 1);
		this.model.startDate = firstDayOfYear.toISOString().split('T')[0];
		this.model.endDate = this.$today;
		this.flagDate = false;
		this.flagDays = false;
	} else if (val === 5) {
		this.model.startDate = format(subDays(this.$today, 7), 'YYYY-MM-DD');
		this.model.endDate = this.$today;
		this.flagDate = true;
		this.flagDays = false;
	}
	this.loadDataAmountPurchases(this.currentSubsidiary);
}
function setModule(value) {
	this.moduleId = value;
	localStorage.setItem('quipu::neWModule', this.moduleId);
}

function runAction({ codeWeb }) {
	this.goTo(codeWeb);
}

function data() {
	return {
		flagDays: true,
		seriesGraphics: [],
		chartOptions: {},
		totalAmountSales: 0,
		accountFourTotalForMonth: 0,
		accountFourTotalForYear: 0,
		accountFiveTotalForMonth: 0,
		accountFiveTotalForYear: 0,
		accountSixTotalForMonth: 0,
		accountSixTotalForYear: 0,
		totalAmountPurchases: 0,
		cards: [{ title: 'Ingresos / Gastos', subtitle: 'Subtitle 1' }],
		typesDate: [
			{ id: 1, name: 'Hoy' },
			{ id: 2, name: 'Ultima Semana' },
			{ id: 3, name: 'Mes Actual' },
			{ id: 4, name: 'Año Actual' },
			{ id: 5, name: 'Rango de Fechas' },
		],
		moduleId: 0,
		isVibrating: false,
		records: [],
		model: {
			startDate: format(subDays(this.$today, 7), 'YYYY-MM-DD'),
			endDate: this.$today,
		},
		customerId: null,
		dialog: false,
		flagDate: false,
		dialogMessage: '',
		settings: {
			arrows: false,
			dots: true,
			infinite: true,
			speed: 2000,
			autoplay: true,
			autoplaySpeed: 2000,
			slidesToShow: 3,
			slidesToScroll: 1,
			cssEase: 'linear',
			responsive: [
				{
					breakpoint: 1024,
					settings: {
						slidesToShow: 3,
						slidesToScroll: 3,
						infinite: true,
						dots: true,
					},
				},
				{
					breakpoint: 600,
					settings: {
						slidesToShow: 2,
						slidesToScroll: 2,
						initialSlide: 2,
					},
				},
				{
					breakpoint: 480,
					settings: {
						slidesToShow: 1,
						slidesToScroll: 1,
					},
				},
			],
		},
		settingsMovil: {
			arrows: false,
			dots: true,
			infinite: true,
			speed: 2000,
			autoplay: true,
			autoplaySpeed: 2000,
			slidesToShow: 1,
			slidesToScroll: 4,
			initialSlide: 0,
			cssEase: 'linear',
			responsive: [
				{
					breakpoint: 1024,
					settings: {
						slidesToShow: 3,
						slidesToScroll: 3,
						infinite: true,
						dots: true,
					},
				},
				{
					breakpoint: 600,
					settings: {
						slidesToShow: 2,
						slidesToScroll: 2,
						initialSlide: 2,
					},
				},
				{
					breakpoint: 480,
					settings: {
						slidesToShow: 1,
						slidesToScroll: 1,
					},
				},
			],
		},
	};
}

export default {
	name: 'statistics',
	created,
	components: {
		actionBar,
		customerList,
		appActions,
		donut,
		pie,
		barchart,
		BaseSelect,
		dashed,
		barchartMovil,
		dateComponentDashboard,
		HeaderSelect: () => import('@/components/shared/inputs/header-select'),
	},
	data,
	methods: {
		onSearchTable,
		...mapActions('subsidiary', {
			$loadSubsidiaries: 'loadSubsidiaries',
			$setCurrentSubsidiary: 'setCurrentSubsidiary',
			$updateSubsidiaries: 'updateSubsidiaries',
		}),
		getDataDate,
		runAction,
		getTotalForAccountMonth,
		getTotalForAccountYear,
		loadDataAmount,
		loadDataAmountPurchases,
		getDate,
		loadRecords,
		setModule,
	},
	computed: {
		...mapGetters('subsidiary', ['currentSubsidiary']),
	},
};
</script>
<style lang="scss" scoped>
.card-container-graphics {
	display: flex;
	flex-wrap: wrap;
	justify-content: space-between;
	margin: 0 15px;
}
.custom-card-graphics:hover {
	transform: scale(1.05);
}
.custom-card-graphics {
	flex: 1 1 calc(33.33% - 4px); /* 33.33% para tres tarjetas por fila */
	margin: 15px 8px; /* Margen de las tarjetas */
	position: relative;
	transition: transform 0.3s ease-in-out;
}
.custom-card-container {
	display: flex;
	align-items: center;
	justify-content: center;
}

.custom-card-background {
	background-color: rgba(0, 0, 0, 0.12);
	padding: 16px;
	margin: 8px;
	border: 1px solid transparent;
	color: black !important;
}

.card-title {
	position: absolute;
	top: -12px;
	left: 50%;
	transform: translateX(-50%);
	background-color: #f2f6f7;
	padding: 4px 8px;
	font-weight: bold;
	color: #085f65;
	text-decoration: underline;
}
.section-statistics {
	background-color: #f1f4fa !important;
	zoom: 110%;
}
.slider-list {
	font-family: font(AvenirRegular) !important;
	font-size: size(small11) !important;
	padding-left: 38px;
	padding-right: 28px;
	@media (max-width: 768px) {
		display: none;
	}
}
.slider-Carousel {
	@media (max-width: 768px) {
		display: none;
	}
}
.slider-Carousel-movil {
	display: none;
	@media (max-width: 768px) {
		display: flex;
	}
}
.padding-legend {
	padding-left: 1vw;
}
.company-modules-route {
	width: 100%;
	color: powderblue !important;
	&[disabled] {
		cursor: not-allowed;
	}
}
.BG {
	width: 210px !important;
	height: 136px;
	flex-grow: 0;
	margin: 0 30px 0 0;
	padding: 28px 93px 18px 28px;
	opacity: 0.8;
	border-radius: 10px;
	// background-color: #fff;
	@media (max-width: 768px) {
		width: 248px !important;
		height: 136px;
	}
	@include flex-between;
	.circleIcon {
		border-radius: 50%;
		width: 70px;
		height: 70px;
		padding: 18px;
		margin-right: 10px;
		opacity: 0.8;
		border: 3px solid #fff;
		display: flex;
		align-items: center;
		justify-content: center;
		img {
			width: 30px;
			height: 30px;
			object-fit: contain;
		}
	}
}

.contentFilter {
	right: -205px;
	position: relative;
}
.graphics2 {
	@media (max-width: 768px) {
		@include flex-center;
		max-width: 1200px;
		margin: 0 auto;
		display: grid;
		gap: 0.2rem;
	}
}
.bar-chart {
	background-color: white;
	width: 540px !important;
	height: 400px;
	border-radius: 10px;
	border: 5px solid PowderBlue !important;
	@media (max-width: 768px) {
		display: none;
	}
	.reports {
		width: 67px;
		height: 23px;
		flex-grow: 0;
		margin: 0 561px 34px 10px;
		font-family: 'AvenirRegular';
		font-size: 14px;
		font-weight: 500;
		font-stretch: normal;
		font-style: normal;
		line-height: normal;
		letter-spacing: normal;
		text-align: left;
		color: #06152b;
	}
}
.bar-chartMovil {
	@media (max-width: 768px) {
		background-color: white;
		width: 370px !important;
		height: 300px;
		border-radius: 10px;
		border: 5px solid PowderBlue !important;
	}
	.reports {
		width: 67px;
		height: 23px;
		flex-grow: 0;
		font-family: 'AvenirRegular';
		font-size: 14px;
		font-weight: 500;
		font-stretch: normal;
		font-style: normal;
		line-height: normal;
		letter-spacing: normal;
		text-align: left;
		color: #06152b;
	}
}
.v-sheet--offset {
	top: -24px;
	position: relative;
}
.do-nut {
	background-color: white;
	width: 540px !important;
	height: 400px;
	border-radius: 10px;
	border: 5px solid PowderBlue !important;
	@media (max-width: 768px) {
		display: none;
	}
	.reports {
		width: 67px;
		height: 23px;
		flex-grow: 0;
		margin: 0 561px 34px 10px;
		font-family: 'AvenirRegular';
		font-size: 14px;
		font-weight: 500;
		font-stretch: normal;
		font-style: normal;
		line-height: normal;
		letter-spacing: normal;
		text-align: left;
		color: #06152b;
	}
}
.do-nutMovil {
	background-color: white;
	width: 370px !important;
	height: 300px;
	border-radius: 10px;
	border: 5px solid PowderBlue !important;
	.reports {
		width: 67px;
		height: 23px;
		flex-grow: 0;
		font-family: 'AvenirRegular';
		font-size: 14px;
		font-weight: 500;
		font-stretch: normal;
		font-style: normal;
		line-height: normal;
		letter-spacing: normal;
		text-align: left;
		color: #06152b;
	}
}
.graphics-contentMovil {
	display: none;
	@media (max-width: 768px) {
		display: grid;
		gap: 0.5rem;
	}
}
.btn-show-categories {
	color: color(primary);
	font-family: font(open-semibold);
	text-decoration: underline;
}

.graphics-circular {
	&-title {
		color: color(opacity-list-price);
		display: block;
		font-family: font(open-semibold);
		font-size: size(small);
		max-width: 74px;
		text-transform: uppercase;
	}

	&-legend {
		align-items: center;
		color: color(opacity-list-price);
		display: flex;
		flex-wrap: wrap;
		font-family: font(open-semibold);
		justify-content: flex-end;
		margin-bottom: 14px;

		&-label {
			display: inline-block;
			font-size: size(small);
			margin-right: auto;
			text-transform: uppercase;
		}

		&-percentage {
			display: inline-block;
			font-size: size(small10);
			min-width: 60px;
			text-align: right;

			.regular {
				font-family: font(open-regular);
			}
		}

		.progress-linear {
			border-radius: 4px !important;
			margin: 0px 5px 0px 15px !important;
			width: 8vw !important;
		}
	}
}

.card-container {
	display: flex;
	flex-wrap: wrap;
	flex: 1 1 calc(50% - 2rem);
	justify-content: center;
	margin-top: 2rem;
	font-family: 'AvenirRegular' !important;
	gap: 1rem;
	padding: 0 2rem;
}

.custom-card {
	flex: 1 1 calc(50% - 2rem);
	max-width: 500px;
	min-width: 280px;
	border-radius: 10px;
	transition: transform 0.3s ease-in-out;
}

.custom-card:hover {
	transform: scale(1.02);
}

@media (max-width: 1068px) {
	.custom-card {
		flex: 1 1 calc(100% - 2rem);
	}
}

.title-action {
	font-size: map-get($sizes, small);
}
.headline {
	font-family: 'AvenirBold' !important;
	font-size: 25px !important;
}
.headlineForMonth {
	font-family: 'AvenirBold' !important;
	font-size: 20px !important;
}
.sliderDinamic {
	@include flex-between;
	.clients {
		width: 64px;
		height: 21px;
		flex-grow: 0;
		font-family: 'AvenirRegular';
		font-size: 14px;
		font-stretch: normal;
		font-style: normal;
		line-height: normal;
		letter-spacing: normal;
		text-align: left;
		color: #06152b;
	}
	.titleModule {
		width: 64px;
		height: 21px;
		flex-grow: 0;
		font-family: font(open-bold);
		font-size: size(small);
		padding: 0px 15px;
		font-stretch: normal;
		font-style: normal;
		line-height: normal;
		letter-spacing: normal;
		text-align: left;
		color: #fff;
	}
}
</style>



// WEBPACK FOOTER //
// src/pages/statistics/page-statistics.vue